import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  menuItem: {
    color: theme.variables.fontColorBlack,
    fontSize: theme.variables.fontSizeMd,
    fontWeight: theme.variables.fontWeight600,
  },

  [theme.breakpoints.down('md')]: {
    fontSize: theme.variables.fontSizeXs,
  },
}))

export default useStyles
